import { Container, Grid, GridItem } from '@chakra-ui/react';
import SmallCard from './SmallCard';

export default function SmallCards({
  cards,
  size = 3,
  dividers = true,
}: {
  cards: {
    image: {
      sourceUrl: string;
      altText: string;
      width?: number;
      height?: number;
    };
    title: string;
    text?: string;
    button?: {
      text: string;
      url: string;
    };
  }[];
  size?: number;
  dividers?: boolean;
}) {
  return (
    <Container mb={{ base: '12', lg: '24' }}>
      <Grid
        gap={{ base: '16', lg: '5' }}
        gridTemplateColumns={{ lg: `repeat(${size}, 1fr)` }}
        bgColor="white"
      >
        {cards.map((card, index, { length }) => (
          <GridItem key={card.title}>
            <SmallCard card={card} index={index} length={length} dividers={dividers} />
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
}
